export default __webpack_public_path__ + "locales/lo-LA/WebPlugins.json?hash=ae62557ac3e5b1b6b37126d95e55c65c";